import { App as AntApp } from 'antd';

import { AppRoutes } from './routes/AppRoutes';
import { setMessageApi } from './utils/messageHolder';

function MessageBridge() {
  const { message } = AntApp.useApp();
  setMessageApi(message);
  return null;
}

export function App() {
  return (
    <>
      <MessageBridge />
      <AppRoutes />
    </>
  );
}
